import { C1Button } from 'c1ui'
import { C1Dialog, C1DialogActions, C1DialogContent, C1DialogTitle } from 'components/core/dialog/C1Dialog'
import { ClosableProps } from 'components/no-ui/context/modal-provider'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ConfirmDeleteSchemaDialogProps = {
    onConfirmDelete: () => void
    schemaName: string
    numBindings: number
} & ClosableProps

export const ConfirmDeleteSchemaDialog: FC<ConfirmDeleteSchemaDialogProps> = ({ onConfirmDelete, close, schemaName, numBindings }) => {
    return <C1Dialog onClose={close} open>
        <C1DialogTitle color="error">
            <FormattedMessage
                id="request_schema_delete_form_title"
                defaultMessage="Are you sure you want to delete <bold>{schema_name}</bold>?"
                values={{
                    schema_name: schemaName,
                    bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
                }}
            />
        </C1DialogTitle>
        <C1DialogContent>
            {numBindings === 0 ? <FormattedMessage
                id="request_schema_delete_form_description_no_bindings"
                defaultMessage="There are no entitlements using this schema."
            />
                : <FormattedMessage
                    id="request_schema_delete_form_description"
                    defaultMessage="Deleting this form will remove it from <bold>{num_bindings, plural, one {# entitlement} other {# entitlements}}</bold>."
                    values={{
                        num_bindings: numBindings,
                        bold: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
                    }}
                />}
        </C1DialogContent>
        <C1DialogActions>
            <C1Button variant="outlined" onClick={close}>
                <FormattedMessage id="request_schema_delete_form_cancel" defaultMessage="Cancel" />
            </C1Button>
            <C1Button variant="contained" color="error" onClick={onConfirmDelete}>
                <FormattedMessage id="request_schema_delete_form_confirm" defaultMessage="Delete" />
            </C1Button>
        </C1DialogActions>
    </C1Dialog>
}
